<template>
  <b-modal
    :visible="true"
    title="Crop Image"
    hide-footer
    centered
    @shown="initCropper"
    @hidden="$emit('close')"
  >
    <div>
      <img ref="image" :src="imageUrl" alt="To Crop" class="img-fluid mb-3" />
      <b-button class="mt-3" variant="primary" @click="crop">Crop & Upload</b-button>
    </div>
  </b-modal>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'CropperModal',
  props: ['imageUrl'],
  data() {
    return {
      cropper: null
    }
  },
  methods: {
    initCropper() {
      if (this.$refs.image) {
        this.cropper = new Cropper(this.$refs.image, {
          aspectRatio: 3 / 2,
          viewMode: 1,
          autoCropArea: 1
        })
      } else {
        console.error('Image ref not available yet.')
      }
    },
    crop() {
      const canvas = this.cropper?.getCroppedCanvas({
        width: 1200,
        height: 1800
      })
      if (canvas) {
        canvas.toBlob(blob => {
          this.$emit('cropped', blob)
          this.$emit('close')
        }, 'image/webp')
      }
    }
  }
}
</script>